<script>
import InfiniteEmissionAndLocationAutoComplete from "../../../components/InfiniteEmissionAndLocationAutoComplete.vue";
import InfiniteTraderAndLocationAutoComplete from "../../../components/InfiniteTraderAndLocationAutoComplete.vue";
import InfiniteTransportRouteAutoComplete from "../../../components/InfiniteTransportRouteAutoComplete.vue";
import InfiniteTraderAutoComplete from "@/driver/components/InfiniteTraderAutoComplete.vue";
import ChooseEmissionModal from "../../../components/ChooseEmissionModal.vue";
import ChooseTraderModal from "../../../components/ChooseTraderModal.vue";
import ChooseTraderButton from "@/driver/components/ChooseTraderButton.vue";
import RegisterConditionPatternModal from "../../../components/RegisterConditionPatternModal.vue";
import Confirm from "@/components/Confirm.vue";
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

/**
 * マニフェスト管理
 * 検索ブロック
 *
 * 検索フォーム
 * @param conditions {Object} 検索条件
 * @property conditions.specify_type { String } マニフェスト番号検索(range:範囲指定, specify: 番号指定)
 * @property conditions.start_no { String } マニフェスト番号 範囲開始
 * @property conditions.end_no { String } マニフェスト番号 範囲終了
 * @property conditions.manifest_numbers { String } マニフェスト番号
 * @property conditions.manifest_type { String } マニフェスト区分
 * @property conditions.supplier_id { Number } 回収先 排出事業者ID
 * @property conditions.supplier_location_id { Number } 回収先 排出事業者種別
 */
export default {
  name: "ManifestSearchBlock",
  components: {
    ItemAutocomplete,
    Confirm,
    InfiniteTraderAutoComplete,
    InfiniteEmissionAndLocationAutoComplete,
    InfiniteTraderAndLocationAutoComplete,
    InfiniteTransportRouteAutoComplete,
    ChooseEmissionModal,
    ChooseTraderModal,
    ChooseTraderButton,
    RegisterConditionPatternModal,
  },
  mixins: [],
  props: {
    /**
     * 検索条件
     * @type { Object }
     */
    conditions: {
      type: Object,
      default: () => {},
    },
    /**
     * 検索パターン
     * @type { Array }
     */
    conditionPatterns: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択中の検索パターン
     * @type { Number }
     * @default 0
     */
    selectableConditionPattern: {
      type: Number,
      default: 0,
    },
    /**
     * JWモード
     * @type { Boolean }
     * @default false
     */
    isJwMode: {
      type: Boolean,
      default: false,
    },
    /**
     * JWNET品目リスト
     * @type { Array }
     */
    items: {
      type: Array,
      default: () => [],
    },

    disposalMethods: {
      type: Array,
      default: () => [],
    },
    voteStaffs: {
      type: Array,
      default: () => [],
    },
    customLabel: {
      type: Object,
      default: null
    },
    stopSearch: {
      type:Boolean,
      default: false,
    },
  },
  data() {
    return {
      /* パネルの開閉 */
      conditionPanel: null,
      showEmissionModal: false,
      showTraderModal: false,
      showDisposerModal: false,
      showRegisterConditionPatternModal: false,
      /* 運搬報告区間指定 */
      sectionNos: [
        { value: 1, text: "第１区間" },
        { value: 2, text: "第２区間" },
        { value: 3, text: "第３区間" },
        { value: 4, text: "第４区間" },
        { value: 5, text: "第５区間" },
      ],
      /* 排出者承認 */
      approvalStatus: [
        { value: "await_approval", code: "▲", text: "未承認" },
        { value: "before_registered", code: "●", text: "承認済（本登録前）" },
        { value: "after_registered", code: "●", text: "承認済（本登録済）" },
        { value: "remand", code: "×", text: "差戻" },
        { value: "none_use_approval", code: "　", text: "対象外" },
      ],
      /* マニフェスト区分 */
      manifestTypes: [
        { value: "dxe_form", text: "電子マニフェスト(EDI)" },
        { value: "other_form", text: "電子マニフェスト(WEB)" },
        { value: "paper_form", text: "紙マニフェスト" },
        { value: "transfer_form", text: "電子マニフェスト(取込)" },
      ],
      /* 運搬報告状況 */
      transportReportStatus: [
        { value: "self_unreported", text: "自社未報告(全て)" },
        { value: "other_unreported", text: "他社未報告" },
        { value: "reported", text: "報告済" },
      ],
      /* 処分報告状況 */
      disposalReportStatus: [
        { value: "self_unreported_jwnet", text: "自社未報告(JWNET未報告)" },
        { value: "self_unreported", text: "自社未報告(JWNET報告済を含む)" },
        { value: "other_unreported", text: "他社未報告" },
        { value: "reported", text: "報告済" },
      ],
      /* 最終報告状況 */
      finalReportStatus: [
        { value: "self_unreported_jwnet", text: "自社未報告(JWNET未報告)" },
        { value: "self_unreported", text: "自社未報告(JWNET報告済を含む)" },
        { value: "other_unreported", text: "他社未報告" },
        { value: "reported", text: "報告済" },
      ],
      /* 期限切れ 期限切れ間近 */
      expiredStatus: [
        { value: "completion", text: "運搬終了報告" },
        { value: "disposal", text: "処分終了報告" },
        { value: "report_final_disposal", text: "最終処分終了報告" },
      ],
      /* 表示順 */
      sortTypes: [
        { value: "updated_date_desc", text: "更新日（降順）▼" },
        { value: "updated_date_asc", text: "更新日（昇順）▲" },
        { value: "created_date_desc", text: "作成日（降順）▼" },
        { value: "created_date_asc", text: "作成日（昇順）▲" },
        { value: "collected_date_desc", text: "引渡し日（降順）▼" },
        { value: "collected_date_asc", text: "引渡し日（昇順）▲" },
      ],
      /* 登録業者/JWNET取込業者 */
      registerTypes: [
        { value: "self_registered", text: "自社" },
        { value: "other_registered", text: "他社" },
      ],
      /* マニフェストコンディションステータス(EDIのみ) */
      manifestConditionStatues: [
        { value: "reserved", text: "予約登録" },
        { value: "manifest_registered", text: "本登録" },
      ],
    };
  },
  computed: {
    currentTabIndex() {
      return this.selectableConditionPattern;
    },
  },
  watch: {},
  mounted() {
    // 最初はハンドラを無効化
    this.handleTabChange = () => {};

    this.$nextTick(() => {
      if (this.$refs.tabs) {
        this.$refs.tabs.internalValue = this.currentTabIndex;
      }

      // 本来のハンドラを復元
      this.handleTabChange = this.realHandleTabChange;
    });
  },
  created() {},
  methods: {
    realHandleTabChange(newIndex) {
      if (newIndex === 0) {
        this.$emit("update:selectableConditionPattern", newIndex);
        this.$emit("userTabChange", newIndex);
        return;
      }
      if (newIndex === this.selectableConditionPattern) return;

      this.$emit("update:selectableConditionPattern", newIndex);
      this.$emit("userTabChange", newIndex);
    },
    handleTabChange(newIndex) {
      // mountedで上書きされるダミー
    },
    /**
     * 削除ボタン クリックイベント
     * 確認メッセージを表示.
     * 指定タブを削除
     * 全項目に切替
     */
    removeTabButtonClickEvent () {
      if (this.selectableConditionPattern === 0) {
        return
      }
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$emit('removeConditionPattern', this.selectableConditionPattern)
        }
      })
    },
    /**
     * クリアボタン クリックイベント
     * 入力内容をクリアする
     */
    clearButtonClickEvent() {
      this.$emit("clear")
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.$emit("search");
    },
    addTabButtonClickEvent() {
      this.showRegisterConditionPatternModal = true;
    },
    /**
     * 引渡日(開始日) 入力イベント
     */
    startDateInputEvent() {
      // 日付選択を解除
      this.conditions.target_date = null;
      this.handleSearch();
    },
    /**
     * 引渡日(終了日) 入力イベント
     */
    endDateInputEvent() {
      // 日付選択を解除
      this.conditions.target_date = null;
      this.handleSearch();

    },
    /**
     * 回収先を選択（排出事業者）ボタン クリックイベント
     */
    showEmissionModalButtonClickEvent() {
      this.showEmissionModal = true;
    },
    showTraderModalButtonClickEvent() {
      this.showTraderModal = true;
    },
    showDisposerModalButtonClickEvent() {
      this.showDisposerModal = true;
    },
    closeDialog() {
      this.showEmissionModal = false;
      this.showTraderModal = false;
      this.showDisposerModal = false;
      this.showRegisterConditionPatternModal = false;
    },
    /**
     * 回収先（排出事業者・事業場） チェンジコールバック
     *
     * @param emission_id { Number } 排出事業者ID
     * @param location_id { Number } 排出事業場ID
     * @param location_code { String } 排出事業場コード
     */
    supplierChangeCallback (emission_id, location_id, location_code) {
      let changed = false;
      if (this.conditions.supplier_id !== emission_id) {
        changed = true;
      }

      if (this.conditions.supplier_location_id !== location_id) {
        changed = true;
      }

      this.conditions.supplier_id = emission_id;
      this.conditions.supplier_type = "Emission";
      this.conditions.supplier_location_id = location_id;
      this.conditions.supplier_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 排出事業者選択モーダル　コールバック
     * @param item
     */
    choseSupplierCallback(item) {
      this.conditions.supplier_id = item.id;
      this.conditions.supplier_type = "Emission";
      this.conditions.supplier_location_id = null;
      this.conditions.supplier_location_code = null;
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();

    },
    /**
     * 回収先（収運・処分事業者）事業者 チェンジコールバック
     * @param trader_id { Number } 事業者ID
     * @param location_id { Number } 事業場ID
     * @param location_code { String } 事業場コード
     */
    supplierTraderChangedCallback (trader_id, location_id, location_code) {

      let changed = false;

      if (this.conditions.supplier_trader_id !== trader_id) {
        changed = true;
      }

      if (this.conditions.supplier_trader_location_id !== location_id) {
        changed = true;
      }

      this.conditions.supplier_trader_id = trader_id;
      this.conditions.supplier_trader_type = "Trader"
      this.conditions.supplier_trader_location_id = location_id;
      this.conditions.supplier_trader_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 回収先（収運・処分事業者）モーダル コールバック
     * @param item
     */
    choseTransportCallback(item) {
      this.conditions.supplier_trader_id = item.id;
      this.conditions.supplier_trader_type = item.type;
      this.conditions.supplier_trader_location_id = null;
      this.conditions.supplier_trader_location_code = null;

      this.$nextTick(() => { this.handleSearch(); })

      this.closeDialog();
    },
    /**
     * 収集運搬業者チェンジ コールバック
     * @param trader_id { Number } 事業者ID
     */
    transporterChangedCallback (trader_id) {

      let changed = false;

      if (this.conditions.transporter_id !== trader_id) {
        changed = true;
      }

      this.conditions.transporter_id = trader_id;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 収集運搬業者モーダル コールバック
     * @param item
     */
    choseTransporterCallback (item) {
      this.conditions.transporter_id = item.id;
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();
    },
    /**
     * 処分業者 チェンジコールバック
     * @param trader_id { Number } 事業者ID
     * @param location_id { Number } 事業場ID
     * @param location_code { String } 事業場コード
     */
    traderChangedCallback (trader_id, location_id, location_code) {

      let changed = false;

      if (this.conditions.trader_id !== trader_id) {
        changed = true;
      }

      if (this.conditions.trader_location_id !== location_id) {
        changed = true;
      }

      this.conditions.trader_id = trader_id;
      this.conditions.trader_location_id = location_id;
      this.conditions.trader_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 処分業者選択モーダル コールバック
     * @param item
     */
    choseDisposerCallback(item) {
      this.conditions.trader_id = item.id;
      this.conditions.trader_location_id = null;
      this.conditions.trader_location_code = null;
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();
    },
    /**
     * 運搬ルートチェンジ コールバック
     * @param route_id
     */
    transportRouteChangedCallback (route_id) {
      this.conditions.transport_route_id = route_id;
      this.$nextTick(() => { this.handleSearch(); })
    },
    /**
     * 検索パターン登録 コールバック
     * @param item { Object } 検索パターン
     */
    registerConditionPatternCallback (item) {
      this.$emit("addConditionPattern", item)
      this.closeDialog();
    },
    handleSearch () {
      if (!this.stopSearch) {
        this.searchButtonClickEvent();
      }
    },
    /**
     * 各種クリアボタン クリックイベント
     * @param keys { String, Array } プロパティ名
     */
    clearEvent (keys) {
      if (Array.isArray(keys)) {
        keys.forEach(key => this.conditions[key] = null);
      } else {
        this.conditions[keys] = null;
      }
      this.handleSearch();
    },
    chipColor(item) {
      let color = null;
      switch (item.value) {
        case "await_approval":
          color = "#F0C000";
          break;
        case "before_registered":
          color = "#f57c00";
          break;
        case "after_registered":
          color = "#0074BA";
          break;
        case "none_use_approval":
          color = "";
          break;
        case "remand":
          color = "red";
          break;
        default:
      }
      return color;
    },
    startDateChangedCallback (value) {
      this.conditions.target_date = null;
      this.conditions.start_date = value;
      this.handleSearch();
    },
    endDateChangedCallback (value) {
      this.conditions.target_date = null;
      this.conditions.end_date = value;
      this.handleSearch();
    },
    /**
     * 運搬終了日 (from) チェンジコールバック
     * @param value
     */
    transportCompleteDateFromChangedCallback (value) {
      this.conditions.transport_completed_date_from = value;
      this.handleSearch();
    },
    /**
     * 運搬終了日 (to) チェンジコールバック
     * @param value
     */
    transportCompleteDateToChangedCallback (value) {
      this.conditions.transport_completed_date_to = value;
      this.handleSearch();
    },
    disposalCompleteDateFromChangedCallback (value) {
      this.conditions.disposal_completed_date_from = value;
      this.handleSearch();
    },
    disposalCompleteDateToChangedCallback (value) {
      this.conditions.disposal_completed_date_to = value;
      this.handleSearch();
    },
    finalDisposalEndFromChangedCallback (value) {
      this.conditions.final_disposal_end_from = value;
      this.handleSearch();
    },
    finalDisposalEndToChangedCallback (value) {
      this.conditions.final_disposal_end_to = value;
      this.handleSearch();
    },
  },
};
</script>
<template>
  <div class="search-block">
    <v-expansion-panels accordion v-model="conditionPanel">
      <v-expansion-panel>
        <v-expansion-panel-header
          class="panel-header-color panel-selectable"
        >
          <strong>
            <v-icon class="panel-header-color"> mdi-magnify </v-icon>
            &nbsp;条件を指定して検索
          </strong>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card v-if="conditions" flat light>
            <v-card-text class="pt-0">

              <!-- 検索パターンタブ -->
              <v-layout>
                <v-flex style="width: 80%" class="py-0">
                  <v-tabs
                    :value="currentTabIndex"
                    ref="tabs"
                    align-with-title
                    show-arrows
                    :key="`tabs-${conditionPatterns.length}`"
                    @change="handleTabChange"
                  >
                    <v-tab
                    >
                      全項目
                    </v-tab>
                    <v-tab
                      v-for="(tab, index) in conditionPatterns"
                      :key="index"
                    >
                      {{ tab.name }}
                    </v-tab>
                  </v-tabs>
                </v-flex>
                <v-flex shrink class="align-self-center">
                  <v-btn color="primary" @click="addTabButtonClickEvent"
                  >検索パターン追加<v-icon>mdi-plus</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
              <!-- /検索パターンタブ -->

              <!-- マニフェスト番号(マニフェスト番号範囲指定, マニフェスト番号指定) -->
              <v-row dense>
                <v-col cols="12" class="my-0">
                  <v-radio-group
                    v-model="conditions.specify_type"
                    dense
                    hide-details="auto"
                    class="mt-0"
                  >
                    <v-row dense>
                      <v-col cols="12" md="7" class="pb-0">
                        <v-row align="center">
                          <v-radio
                            value="range"
                            class="mr-5 mt-2"
                            :class="{ 'full-width': $vuetify.breakpoint.smAndDown }"
                          >
                            <template v-slot:label>
                              <span class="search-block__small-label">マニフェスト番号範囲指定</span>
                            </template>
                          </v-radio>
                          <v-text-field
                            v-model="conditions.start_no"
                            :disabled="conditions.specify_type !== 'range'"
                            clearable
                            dense
                            hide-details="auto"
                            label="開始番号"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%;"
                            :class="{
                              'mr-5': $vuetify.breakpoint.mdAndUp,
                              'mt-2': !$vuetify.breakpoint.mdAndUp,
                              'is-small-size': $vuetify.breakpoint.mdAndUp,
                              'full-width': $vuetify.breakpoint.smAndDown
                            }"
                            @click:clear="clearEvent('start_no')"
                            @blur="handleSearch"
                          />
                          <v-text-field
                            v-model="conditions.end_no"
                            :disabled="conditions.specify_type !== 'range'"
                            clearable
                            dense
                            hide-details="auto"
                            label="終了番号"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%;"
                            class="mt-1"
                            :class="{
                              'mr-5': $vuetify.breakpoint.mdAndUp,
                              'mt-2': !$vuetify.breakpoint.mdAndUp,
                              'is-small-size': $vuetify.breakpoint.mdAndUp,
                              'full-width': $vuetify.breakpoint.smAndDown
                            }"
                            @click:clear="clearEvent('end_no')"
                            @blur="handleSearch"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="5" class="pb-0">
                        <v-row align="center">
                          <v-radio
                            value="specify"
                            class="mr-5 mt-2"
                            :class="{
                              'full-width': $vuetify.breakpoint.smAndDown
                            }"
                          >
                            <template v-slot:label>
                              <span class="search-block__small-label">マニフェスト番号指定</span>
                            </template>
                          </v-radio>
                          <v-text-field
                            v-model="conditions.manifest_numbers"
                            :disabled="conditions.specify_type !== 'specify'"
                            clearable
                            dense
                            hide-details="auto"
                            outlined
                            persistent-placeholder
                            placeholder="空白・カンマ区切りで入力"
                            rounded
                            style="font-size: 80%"
                            :class="{
                             'is-small-size': $vuetify.breakpoint.mdAndUp,
                              'full-width': $vuetify.breakpoint.smAndDown
                            }"
                            @click:clear="clearEvent('manifest_numbers')"
                            @blur="handleSearch"
                          />
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- /マニフェスト番号(範囲指定, 番号指定) -->

              <!-- マニフェスト区分, ステータス(EDIのみ), 引渡し日(開始日), 引渡し日(終了日), JWNET取扱品目  -->
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.manifest_type"
                    :items="manifestTypes"
                    background-color="white"
                    clearable
                    dense
                    hide-details="auto"
                    label="マニフェスト区分"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @click:clear="clearEvent('manifest_type')"
                    @change="handleSearch"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.manifest_condition_status"
                    :items="manifestConditionStatues"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="ステータス(EDIのみ)"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('manifest_condition_status')"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.start_date"
                    @dateChangedCallback="startDateChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.start_date"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="引渡し日"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent(['start_date', 'target_date'])"
                      >
                        <template v-slot:append-outer>
                          <div
                            v-if="$vuetify.breakpoint.mdAndUp"
                            style="vertical-align: middle"
                          >
                            〜
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                  </cs-date-picker>
                </v-col>

                <v-col cols="12" md="2">

                  <cs-date-picker
                    :date.sync="conditions.end_date"
                    @dateChangedCallback="endDateChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.end_date"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="終了日"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent(['end_date', 'target_date'])"
                      />
                    </template>
                  </cs-date-picker>

                </v-col>

                <v-col cols="12" md="4">
                  <item-autocomplete
                    v-model="conditions.item_id"
                    :items="items"
                    classes="search-font"
                    clearable
                    dense
                    multiple
                    label="JWNET取扱品目"
                    outlined
                    persistent-placeholder
                    rounded
                    chips
                    small-chips
                    deletable-chips
                    @change="handleSearch"
                  />
                </v-col>

              </v-row>
              <!-- /マニフェスト区分, ステータス(EDIのみ), 引渡し日(開始日), 引渡し日(終了日), JWNET取扱品目  -->

              <!-- 回収先（排出事業者）, 排出事業場コード, 排出事業場名 -->
              <infinite-emission-and-location-auto-complete
                :supplier-id="conditions.supplier_id"
                :location-id="conditions.supplier_location_id"
                :location-code="conditions.supplier_location_code"
                classes="search-font"
                md="3"
                rounded
                supplier-label="回収先（排出事業者）"
                location-label="回収先事業場"
                supplier-md="4"
                location-md="4"
                uncontrol-disabled
                @update:values="supplierChangeCallback"
              >
                <template v-slot:supplier-append-outer>
                  <v-btn
                    class="primary"
                    small
                    @click="showEmissionModalButtonClickEvent"
                  >
                    回収先を選択
                  </v-btn>
                  <choose-emission-modal
                    :enable="showEmissionModal"
                    :without-general-form="true"
                    @selected="choseSupplierCallback"
                    @close="closeDialog"
                  />
                </template>
                <template v-slot:location-item="slotProps">
                  <v-chip
                    :title="slotProps.item?.code"
                    color="#e0ffff"
                    label
                    small
                  >
                    {{ slotProps.item?.code }}
                  </v-chip>
                  &nbsp;{{ slotProps.item.text }}
                  <small class="text--disabled">&nbsp;{{ slotProps.item.address }}</small>
                </template>
                <template v-slot:append>
                  <!-- 排出事業場コード -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="conditions.location_code"
                      style="font-size: 80%"
                      dense
                      hide-details="auto"
                      label="排出事業場コード"
                      clearable
                      outlined
                      persistent-placeholder
                      placeholder="例）K001"
                      rounded
                      @blur="handleSearch"
                      @click:clear="clearEvent('location_code')"
                    />
                  </v-col>
                  <!-- /排出事業場コード -->
                  <!-- 排出事業場名称 -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="conditions.location_name"
                      style="font-size: 80%"
                      dense
                      hide-details="auto"
                      label="排出事業場名称"
                      clearable
                      outlined
                      persistent-placeholder
                      placeholder="部分一致で検索"
                      rounded
                      @blur="handleSearch"
                      @click:clear="clearEvent('location_name')"
                    />
                  </v-col>
                  <!-- /排出事業場名称 -->
                </template>
              </infinite-emission-and-location-auto-complete>
              <!-- /回収先（排出事業者）, 排出事業場コード, 排出事業場名 -->

              <!-- 回収先（収運・処分事業者）, 収集運搬業者 -->
              <infinite-trader-and-location-auto-complete
                :trader-id="conditions.supplier_trader_id"
                :location-id="conditions.supplier_trader_location_id"
                :location-code="conditions.supplier_trader_location_code"
                classes="search-font"
                md="3"
                rounded
                search-type="either"
                trader-label="回収先（収運・処分事業者）"
                trader-md="4"
                location-label="回収先事業者"
                location-md="4"
                @update:values="supplierTraderChangedCallback"
              >
                <template v-slot:trader-append-outer>
                  <v-btn
                    color="primary"
                    small
                    @click="showTraderModalButtonClickEvent"
                  >
                    回収先を選択
                  </v-btn>
                  <choose-trader-modal
                    :enable="showTraderModal"
                    @close="closeDialog"
                    @selected="choseTransportCallback"
                  />
                </template>
                <template v-slot:location-item="slotProps">
                  <v-chip
                    :title="slotProps.item?.code"
                    color="#e0ffff"
                    label
                    small
                  >
                    {{ slotProps.item?.code }}
                  </v-chip>
                  &nbsp;{{ slotProps.item.text }}
                  <small class="text--disabled">&nbsp;{{ slotProps.item.address }}</small>
                </template>
                <template v-slot:append>
                  <v-col cols="12" md="4">
                    <infinite-trader-auto-complete
                      :trader-id="conditions.transporter_id"
                      classes="search-font"
                      search-type="transport"
                      with-none-location
                      rounded
                      label="収集運搬業者"
                      @update:values="transporterChangedCallback"
                    >
                      <template v-slot:append-outer>
                        <choose-trader-button
                          :small-button="true"
                          :search-type="`transport`"
                          :button-caption="`収集運搬業者を選択`"
                          with-none-location
                          @choseTraderCallback="choseTransporterCallback"
                        />
                      </template>
                    </infinite-trader-auto-complete>
                  </v-col>
                </template>
              </infinite-trader-and-location-auto-complete>
              <!-- /回収先（収運・処分事業者）, 収集運搬業者 -->

              <!-- 処分場, ルート -->
              <infinite-trader-and-location-auto-complete
                :trader-id="conditions.trader_id"
                :location-id="conditions.trader_location_id"
                :location-code="conditions.trader_location_code"
                classes="search-font"
                md="3"
                rounded
                search-type="trader"
                trader-label="処分事業者"
                location-label="処分事業場"
                trader-md="4"
                location-md="4"
                @update:values="traderChangedCallback"
              >
                <template v-slot:trader-append-outer>
                  <v-btn
                    color="primary"
                    small
                    @click="showDisposerModalButtonClickEvent"
                  >
                    処分場を選択
                  </v-btn>
                  <choose-trader-modal
                    :enable="showDisposerModal"
                    search-type="trader"
                    @close="closeDialog"
                    @selected="choseDisposerCallback"
                  />
                </template>
                <template v-slot:location-item="slotProps">
                  <v-chip
                    :title="slotProps.item?.code"
                    color="#e0ffff"
                    label
                    small
                  >
                    {{ slotProps.item?.code }}
                  </v-chip>
                  &nbsp;{{ slotProps.item.text }}
                  <small class="text--disabled">&nbsp;{{ slotProps.item.address }}</small>
                </template>
                <template v-slot:append>
                  <v-col cols="12" md="3">
                    <infinite-transport-route-auto-complete
                      :transport-route-id="conditions.transport_route_id"
                      classes="search-font"
                      rounded
                      @update:values="transportRouteChangedCallback"
                    />
                  </v-col>

                </template>
              </infinite-trader-and-location-auto-complete>
              <!-- /処分場, ルート -->

              <!-- 受注番号ありのみ検索, 受注番号, 引取搬入番号, DXEマニ番号(1次), DXEマニ番号(2次), マニ取消済のみ検索 -->
              <v-row>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="conditions.ordered"
                    class="mt-2"
                    label="受注番号ありのみ検索"
                    dense
                    hide-details="auto"
                    @change="handleSearch"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.order_no"
                    dense
                    hide-details="auto"
                    label="受注番号"
                    clearable
                    outlined
                    persistent-placeholder
                    persistent-hint
                    rounded
                    placeholder="受注番号カンマ区切りで入力"
                    hint="例: 1, 2, 3"
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('order_no')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.request_no"
                    dense
                    hide-details="auto"
                    label="引取搬入番号"
                    clearable
                    outlined
                    persistent-hint
                    persistent-placeholder
                    rounded
                    placeholder="引取搬入番号をカンマ区切りで入力"
                    hint="例: 1, 2, 3"
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('request_no')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.manifest_id"
                    dense
                    hide-details="auto"
                    label="DXEマニ番号(1次)"
                    clearable
                    outlined
                    persistent-hint
                    persistent-placeholder
                    rounded
                    placeholder="カンマ区切りで入力"
                    hint="例: 1, 2, 3"
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('manifest_id')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.relation_manifest_id"
                    dense
                    hide-details="auto"
                    label="DXEマニ番号(2次)"
                    clearable
                    outlined
                    persistent-hint
                    persistent-placeholder
                    rounded
                    placeholder="カンマ区切りで入力"
                    hint="例: 1, 2, 3"
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('relation_manifest_id')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="conditions.canceled"
                    class="mt-2"
                    label="マニ取消済のみ検索"
                    dense
                    hide-details="auto"
                    @change="handleSearch"
                  />
                </v-col>
              </v-row>
              <!-- /受注番号ありのみ検索, 受注番号, 引取搬入番号, DXEマニ番号(1次), DXEマニ番号(2次), マニ取消済のみ検索 -->

              <!-- 運搬報告状況, 運搬終了日 (from), 運搬終了日 (to), 運搬報告区間指定, 区間1運搬事業者 -->
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.transport_report_state"
                    :items="transportReportStatus"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="運搬報告状況"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('transport_report_state')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.transport_completed_date_from"
                    @dateChangedCallback="transportCompleteDateFromChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.transport_completed_date_from"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="運搬終了日 (from)"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent('transport_completed_date_from')"
                      >
                        <template v-slot:append-outer>
                          <div
                            v-if="$vuetify.breakpoint.mdAndUp"
                            style="vertical-align: middle"
                          >
                            〜
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                  </cs-date-picker>
                </v-col>
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.transport_completed_date_to"
                    @dateChangedCallback="transportCompleteDateToChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.transport_completed_date_to"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="運搬終了日 (to)"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent('transport_completed_date_to')"
                      />
                    </template>
                  </cs-date-picker>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.section_no"
                    :items="sectionNos"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="運搬報告区間指定"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('section_no')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.section_1_transporter"
                    :items="registerTypes"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="区間1運搬事業者"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('section_1_transporter')"
                  />
                </v-col>
              </v-row>
              <!-- /運搬報告状況, 運搬終了日 (from), 運搬終了日 (to), 運搬報告区間指定, 区間1運搬事業者 -->

              <!-- 処分報告状況, 処分終了日 (from), 処分終了日 (to), 処分方法 -->
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.disposal_report_state"
                    :items="disposalReportStatus"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="処分報告状況"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('disposal_report_state')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.disposal_completed_date_from"
                    @dateChangedCallback="disposalCompleteDateFromChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.disposal_completed_date_from"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="処分終了日 (from)"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent('disposal_completed_date_from')"
                      >
                        <template v-slot:append-outer>
                          <div
                            v-if="$vuetify.breakpoint.mdAndUp"
                            style="vertical-align: middle"
                          >
                            〜
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                  </cs-date-picker>
                </v-col>
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.disposal_completed_date_to"
                    @dateChangedCallback="disposalCompleteDateToChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.disposal_completed_date_to"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="処分終了日 (to)"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent('disposal_completed_date_to')"
                      />
                    </template>
                  </cs-date-picker>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.disposal_method_ids"
                    :items="disposalMethods"
                    clearable
                    dense
                    hide-details="auto"
                    label="処分方法"
                    outlined
                    persistent-placeholder
                    rounded
                    multiple
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('disposal_method_ids')"
                  />
                </v-col>

              </v-row>
              <!-- /処分報告状況, 処分終了日 (from), 処分終了日 (to), 処分方法, -->

              <!-- 最終報告状況, 最終終了日 (from), 最終終了日 (to), 排出者承認, 表示順 -->
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.final_report_state"
                    :items="finalReportStatus"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="最終報告状況"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('final_report_state')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.final_disposal_end_from"
                    @dateChangedCallback="finalDisposalEndFromChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.final_disposal_end_from"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="最終終了日 (from)"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent('final_disposal_end_from')"
                      >
                        <template v-slot:append-outer>
                          <div
                            v-if="$vuetify.breakpoint.mdAndUp"
                            style="vertical-align: middle"
                          >
                            〜
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                  </cs-date-picker>
                </v-col>
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.final_disposal_end_to"
                    @dateChangedCallback="finalDisposalEndToChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.final_disposal_end_to"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="最終終了日 (to)"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent('final_disposal_end_to')"
                      />
                    </template>
                  </cs-date-picker>
                </v-col>

              </v-row>
              <!-- /最終報告状況, 最終終了日 (from), 最終終了日 (to) -->

              <!-- 登録業者/JWNET取込業者, DXE起票担当者, 廃棄物の名称 -->
              <v-row>

                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.self_manifest"
                    :items="registerTypes"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="登録業者/JWNET取込業者"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('self_manifest')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-combobox
                    v-model="conditions.vote_staff"
                    :items="voteStaffs"
                    :return-object="false"
                    clearable
                    dense
                    hide-details="auto"
                    label="DXE起票担当者"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.waste_name"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="廃棄物の名称"
                    outlined
                    rounded
                    persistent-placeholder
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('waste_name')"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="conditions.manifest_search_keyword"
                    style="font-size: 80%"
                    clearable
                    dense
                    hide-details="auto"
                    label="マニフェスト検索キーワード"
                    outlined
                    persistent-placeholder
                    persistent-hint
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('manifest_search_keyword')"
                  />
                </v-col>

              </v-row>


              <!-- 排出者承認, 期限切れのみ検索(EDIのみ), 期限切れ間近のみ検索(EDIのみ), 表示順 -->
              <v-row>

                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.approval_state"
                    :items="approvalStatus"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="排出者承認"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('approval_state')"
                  >
                    <template v-slot:item="slotProps">
                      <v-chip
                        :title="slotProps.item.code"
                        :text-color="chipColor(slotProps.item)"
                        label
                        small
                        style="background-color: rgba(0, 0, 0, 0)"
                      >
                        {{ slotProps.item.code }} </v-chip
                      >&nbsp;
                      <div style="font-size: 80%">
                        {{ slotProps.item.text }}&nbsp;
                      </div>
                    </template>
                  </v-select>
                </v-col>

                <!-- 期限切れ間近検索(EDIのみ) -->
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.neared_status"
                    :items="expiredStatus"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="期限切れ間近(EDI)"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('neared_status')"
                  />
                </v-col>
                <!-- /期限切れ間近検索(EDIのみ) -->

                <!-- 期限切れ検索(EDIのみ) -->
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.expired_status"
                    :items="expiredStatus"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="期限切れ(EDI)"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                    @click:clear="clearEvent('expired_status')"
                  />
                </v-col>
                <!-- /期限切れ検索(EDIのみ) -->

                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.sort_type"
                    :items="sortTypes"
                    dense
                    hide-details="auto"
                    label="表示順"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  />
                </v-col>


              </v-row>
              <!-- /排出者承認, 期限切れのみ検索(EDIのみ), 期限切れ間近のみ検索(EDIのみ), 表示順 -->

              <!-- カスタムラベル -->
              <v-row v-if="isJwMode">
                <v-col
                  v-if="customLabel.custom_labels1_use"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="conditions.custom_labels_1"
                    :disabled="conditions.custom_labels_1_unregistered"
                    :label="customLabel.custom_labels1_name"
                    clearable
                    dense
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('custom_labels_1')"
                  />
                </v-col>

                <v-col
                  v-if="customLabel.custom_labels2_use"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="conditions.custom_labels_2"
                    dense
                    hide-details="auto"
                    :label="customLabel.custom_labels2_name"
                    :disabled="conditions.custom_labels_2_unregistered"
                    clearable
                    outlined
                    persistent-placeholder
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('custom_labels_2')"
                  />
                </v-col>

                <v-col
                  v-if="customLabel.custom_labels3_use"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="conditions.custom_labels_3"
                    dense
                    hide-details="auto"
                    :label="customLabel.custom_labels3_name"
                    :disabled="conditions.custom_labels_3_unregistered"
                    clearable
                    outlined
                    persistent-placeholder
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('custom_labels_3')"
                  />
                </v-col>

                <v-col
                  v-if="customLabel.custom_labels4_use"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="conditions.custom_labels_4"
                    dense
                    hide-details="auto"
                    :label="customLabel.custom_labels4_name"
                    :disabled="conditions.custom_labels_4_unregistered"
                    clearable
                    outlined
                    persistent-placeholder
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('custom_labels_4')"
                  />
                </v-col>

                <v-col
                  v-if="customLabel.custom_labels5_use"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="conditions.custom_labels_5"
                    dense
                    hide-details="auto"
                    :label="customLabel.custom_labels5_name"
                    :disabled="conditions.custom_labels_5_unregistered"
                    clearable
                    outlined
                    persistent-placeholder
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('custom_labels_5')"
                  />
                </v-col>

                <v-col
                  v-if="customLabel.custom_labels6_use"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="conditions.custom_labels_6"
                    dense
                    hide-details="auto"
                    :label="customLabel.custom_labels6_name"
                    :disabled="conditions.custom_labels_6_unregistered"
                    clearable
                    outlined
                    persistent-placeholder
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('custom_labels_6')"
                  />
                </v-col>
              </v-row>

              <v-row v-if="isJwMode">
                <v-col v-if="customLabel.custom_labels1_use" cols="12" md="2" >
                  <v-checkbox
                    v-model="conditions.custom_labels_1_unregistered"
                    label="未入力データのみ検索"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent('detail')"
                  />
                </v-col>

                <v-col v-if="customLabel.custom_labels2_use" cols="12" md="2">
                  <v-checkbox
                    v-model="conditions.custom_labels_2_unregistered"
                    label="未入力データのみ検索"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent('detail')"
                  />
                </v-col>

                <v-col v-if="customLabel.custom_labels3_use" cols="12" md="2">
                  <v-checkbox
                    v-model="conditions.custom_labels_3_unregistered"
                    label="未入力データのみ検索"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent('detail')"
                  />
                </v-col>

                <v-col v-if="customLabel.custom_labels4_use" cols="12" md="2">
                  <v-checkbox
                    v-model="conditions.custom_labels_4_unregistered"
                    label="未入力データのみ検索"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent('detail')"
                  />
                </v-col>

                <v-col v-if="customLabel.custom_labels5_use" cols="12" md="2">
                  <v-checkbox
                    v-model="conditions.custom_labels_5_unregistered"
                    label="未入力データのみ検索"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent('detail')"
                  />
                </v-col>

                <v-col v-if="customLabel.custom_labels6_use" cols="12" md="2">
                  <v-checkbox
                    v-model="conditions.custom_labels_6_unregistered"
                    label="未入力データのみ検索"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent('detail')"
                  />
                </v-col>
              </v-row>
              <!-- /カスタムラベル -->

            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="currentTabIndex > 0"
                color="error"
                @click="removeTabButtonClickEvent"
              >
                削除
              </v-btn>
              <v-spacer />
              <v-btn
                @click="clearButtonClickEvent"
              >
                &emsp;クリア&emsp;
              </v-btn>

              <v-btn color="primary" @click="searchButtonClickEvent">
                <v-icon> mdi-magnify </v-icon>
                  &nbsp;検索
                </v-btn>
              </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <register-condition-pattern-modal
      :enable="showRegisterConditionPatternModal"
      :conditions.sync="conditions"
      classification="manifests"
      @close="closeDialog"
      @register="registerConditionPatternCallback"
    />
    <confirm ref="confirm" />
  </div>
</template>
<style lang="scss">
.search-block {
  & .v-expansion-panel-content__wrap {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  &__small-label {
    font-size: 0.875rem;
  }
}

.is-small-size {
  width: 10vw;
}

</style>
